exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".approval[data-v-47c55f98]{padding:20px;position:relative;background:#fff}.footer[data-v-47c55f98]{border-top:1px solid #ccc;padding:15px}.custom-a[data-v-47c55f98]{color:#5597ec;text-decoration:underline}.custom-a[data-v-47c55f98]:hover{color:red}.content[data-v-47c55f98] .el-form-item{margin-bottom:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":0,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-47c55f98","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./pages/console/dingComponents/dingSignApproval.vue
// module id = PIqX
// module chunks = 7 30 56 108